//@flow
import React from 'react';
import css from './navbar.css';
import {
  FontAwesomeIcon as FontAwesome
} from '@fortawesome/react-fontawesome';
import {
  faBars
} from '@fortawesome/free-solid-svg-icons';
import {
  NavLink
} from 'react-router-dom'
import {
  Actions
} from './actions';
import MediaQuery from 'react-responsive';

type Props = {
  store: Object,
  items: Object
}


class MainMenu extends React.Component < Props > {

  handleClick(e: SyntheticInputEvent < * > ) {
    Actions.setShowMenu(false);
  }

  handleToggleMore(e: SyntheticInputEvent < * > ) {
    if (this.props.store.get('showMenu') === true) {
      Actions.setShowMenu(false)
    } else {
      Actions.setShowMenu(true)
    }
  }
  render() {
    const moreButton = <div className={css.link} onClick={(e)=>this.handleToggleMore(e)} >
      More&nbsp;<FontAwesome icon={faBars}/>
    </div>;
    const menuButton = <div className={[css.link,css.menuButton].join(" ")} onClick={(e)=>this.handleToggleMore(e)} >
      Menu&nbsp;<FontAwesome icon={faBars}/>
    </div>;


    let items = [];
    Object.entries(this.props.items).forEach(([k, v]) => {
      if (!v) return;
      items.push(<NavLink key={k} onClick={(e)=>this.handleClick(e)} to={v} className={css.link} activeClassName={css.selected}>{k}</NavLink>);
      items.push(<div key={`${k}div`} className={css.verticalDivider}>&nbsp;</div>);
    })
    // items.pop();
    return <div className={css.mainMenu}>
      <MediaQuery minWidth={767}>
      {items}
    </MediaQuery>
    <MediaQuery minWidth={767}>
    {(matches) => {
    if (matches) {
      return moreButton;
    } else {
      return menuButton;
    }
    }}
  </MediaQuery>

</div>
  }
}
export default MainMenu;